module.exports = __webpack_public_path__ + "img/boxing-glove.fe038539.svg";